import { Observable } from "rxjs";
import { GeoAddress, GeoCoordinatesRequest } from "../domain";

export abstract class GeoCoordinateRepository {

    abstract getGeoCoordinates(request: GeoCoordinatesRequest): Observable<GeoAddress>;
}
